import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsPriorAuthorizationsEntityWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberDetailsPriorAuthorizationsEntityWidgetService } from 'services/memberDetailsPriorAuthorizationsEntityWidget';
 *
 * // create service instance and send/cancel request
 * const memberDetailsPriorAuthorizationsEntityWidgetService = new MemberDetailsPriorAuthorizationsEntityWidgetService();
 * const result = await memberDetailsPriorAuthorizationsEntityWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberDetailsPriorAuthorizationsEntityWidgetService.cancel(); // cancel an active request
 */
export class MemberDetailsPriorAuthorizationsEntityWidgetService extends HttpService {

    // make request and fetch component data
    async fetchComponentData(  { url = {}, data = {} } = {}  ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component', {} )
            };
            
        } catch( errResponse ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }
}
